import { Col, Row } from "../../components/Grid";
import { GradientSpinner } from "../../components/progress/Spinner";
import { Headline, Title2 } from "../../components/Typography";
import { useLoadingText } from "../../hooks/loading";

type Type = "spinnerOnly" | "largeText" | "smallText";

interface Props {
  initialLoadingText?: string;
  type?: Type;
}

export const LoadingPlaceholder = ({
  initialLoadingText,
  type = "spinnerOnly",
}: Props) => {
  let defaultLoadingText = useLoadingText();
  if (initialLoadingText) {
    defaultLoadingText = useLoadingText(initialLoadingText);
  }

  let loader;
  if (type === "largeText") {
    loader = (
      <Col flex={1} align="center" justify="center">
        <GradientSpinner size={120} />
        <Title2
          css={`
            color: var(--highlight-text);
            margin-bottom: var(--spacing-sm);
          `}
        >
          {defaultLoadingText}
        </Title2>
      </Col>
    );
  } else if (type === "smallText") {
    loader = (
      <Row
        align="center"
        css={`
          margin-top: var(--spacing-md);
        `}
      >
        <GradientSpinner />
        <Headline>{defaultLoadingText}</Headline>
      </Row>
    );
  } else {
    loader = <GradientSpinner size={120} />;
  }

  return (
    <Col flex={1} align="center" justify="center">
      {loader}
    </Col>
  );
};
